export default {
  ja: {
    manage: {
      logs_management: {
        operation_management: '運用管理',
        operation_log_management: '操作ログ管理',
        log_management: 'ログ管理',
        filter: '絞り込み',
        login_code: 'ユーザーID',
        operation: '操作',
        search_range: '検索範囲',
        order: '並び順',
        ascending_order: '昇順',
        descending_order: '降順',
        search: '検索',
        excel_output: 'Excel出力',
        cancel: 'キャンセル',
        date_and_time: '日時',
        ipaddress: 'IPアドレス',
        detail: '詳細',
        not_found: '該当する情報がありません。',
        operation_log_output: '操作ログのExcel出力',
        dash: '~',
        other: 'その他',
      },
      operations: {
        general: '全般',
        attendance: '受講',
        answer: '回答',
        initial_display: '初期表示',
        get_list: '一覧取得',
        get_detail: '詳細取得',
        register: '登録',
        edit: '編集',
        delete: '削除',
        login: 'ログイン',
        logout: 'ログアウト',
      },
      functions: {
        questionnaire: 'アンケート',
        course: 'コース',
        contents: 'コンテンツ',
        operation_log_management: '操作ログ管理',
        common: '一般',
      },
      masterfields: {
        title_index: 'マスター項目一覧',
        title_create: 'マスター項目追加',
        title_edit: 'マスター項目編集',
        title_delete: 'マスター項目削除',
        list_header_format: '項目形式',
        list_header_field_name: '項目名',
        field_name: '項目名',
        field_description: '項目の説明',
        format: '項目の形式',
        is_enabled: '項目の有効・無効',
        select_option1: '選択肢１',
        select_option2: '選択肢２',
        select_option3: '選択肢３',
        radio_textarea: 'テキストエリア',
        radio_textbox: 'テキストボックス',
        sentence: '文章',
        textbox: '文章（テキストボックス）',
        textarea: '文章（テキストエリア）',
        create_phase_selectFormat: '形式選択',
        reached_to_upper_limit: 'マスター項目の登録数が上限に達したため、追加できません。',
        add_confirmation: '登録内容をご確認ください',
      },
      masterdata: {
        btn_edit_field: '項目編集',
        btn_edit_data: 'データ編集',
        title_index: 'マスターデータ一覧',
        title_edit: 'マスターデータ編集',
        list_is_default_value_0: '',
        list_is_default_value_1: '○',
        checkbox_is_default_value: '初期値とする',
        master_field_list: 'マスター項目一覧',
        field_name: '項目名',
        field_description: '項目の説明',
        format: '形式',
        is_enabled: '項目の有効・無効',
        data_name: 'データ名',
        is_default_value: '初期値設定',
        field_detail: '項目詳細',
        sentence: '文章',
        textbox: '文章（テキストボックス）',
        textarea: '文章（テキストエリア）',
        is_default_value_0: '初期値としない',
        is_default_value_1: '初期値とする',
        not_deletable_is_default_value: '必須項目かつ初期値として設定されているデータは削除できません。',
        not_deletable_user_additional_data: '必須項目かつユーザーに割り当て済みのデータは削除できません。',
      },
      session: {
        session_management: 'セッション管理',
        sessionid: 'セッションID',
        status: '状態',
        login_status: 'ログイン中',
        logout_status: 'ログアウト済み',
        title_index: 'セッション一覧',
        loginat: 'ログイン日時',
        logoutat: 'ログアウト日時',
        session_detail: 'セッション詳細',
        forcibly_logoff: '強制ログオフ',
        group: 'グループ',
        role: '役職',
        browzer: 'ブラウザ',
        operation_system: 'OS',
        latest_operation_log: '最新の操作ログ',
        ipaddress: 'IPアドレス',
        operation: '操作',
        session_delete: 'セッション削除',
        delete_confirm_message: '選択したユーザーをログオフします。',
        delete_complete_message: '以下のユーザーをログオフしました。',
        delete_error_message: 'ログオフできませんでした。ユーザーは既にログアウト済みです。',
        delete_confirmation_dialog: '強制ログオフを実行します、よろしいですか。ユーザーが操作中の場合、その操作は保存されず中断されます。',
      },
      entries: {
        approve:'承認',
        approval_user: '承認者',
        approve_complete: '申請を承認し、ユーザー登録しました。',
        approve_confirm: '申請を承認します。よろしいですか？',
        approved_at: '承認日',
        confirm_approval: '以下の申請を承認します。',
        confirm_rejection: '以下の申請を却下します。',
        delete_confirm: '申請を削除します。よろしいですか？',
        do_mail_send: '承認・却下通知',
        do_send_approval_mail: '承認通知',
        do_send_rejection_mail: '却下通知',
        entried_at: '申込日',
        entriedat_incorrect_period: '申込日の期間が正しくありません。',
        entry_status: '処理状態',
        entry_status_approved: '承認済',
        entry_status_expired: '期限切',
        entry_status_identification: '仮申請',
        entry_status_pending: '承認待',
        entry_status_rejected: '却下',
        identification_clicked: '対象のデータは申請者の情報入力待ちです。',
        multi_approval: '一括承認',
        multi_rejection: '一括却下',
        pending: '承認待',
        reject: '却下',
        reject_complete: '申請を却下しました。',
        reject_confirm: '申請を却下します。よろしいですか？',
        reject_user: '却下者',
        rejected_at: '却下日',
        rejection_reason: '却下理由',
        select: '対象選択',
        show_expired: '期限切を表示',
        title: 'ユーザー利用申請情報一覧',
        title_delete: 'ユーザー利用申請情報削除',
        title_edit: 'ユーザー利用申請情報承認・却下',
        title_multi_operation: 'ユーザー利用申請情報一括操作',
      },
      folders: {
        brows: "閲覧",
        contents_count: "コンテンツ数",
        contents_list: "コンテンツ一覧",
        create_modal_title: "フォルダ作成",
        edit_modal_title: "フォルダ編集",
        folder_name: "フォルダ名",
        permission_having_setting: "設定あり",
        permission_no_setting: "設定しない",
        permission_setting: "権限設定",
        permission_template: "権限テンプレート",
        size: "サイズ",
      },
      contents: {
        alarm: 'アラーム',
        alarm_count: "回目",
        answer: "回答",
        answer_method: "回答形式",
        auto: "自動",
        brunch: "分岐",
        bulk_answer: "一括解答形式",
        candidate_correct_answer: "正答の候補",
        certificate: "修了証",
        choice: "選択式",
        choice_appendices_guide: "選択肢{index}に補足資料を付ける",
        choices: "選択肢",
        choices_order: "選択肢の順番",
        content: "内容",
        content_selection_guide: "追加するコンテンツを選択してください。",
        content_to_create: "作成するコンテンツ",
        contents: "コンテンツ内容",
        contents_detail: "コンテンツ詳細",
        contents_list: "コンテンツ一覧",
        contents_name: "コンテンツ名",
        contents_type: "コンテンツ種類",
        correct: "正答",
        counter_for_questions: "問",
        create_explanation: "解説の作成",
        create_input_contents: "入力コンテンツ作成",
        create_output_contents: "出力コンテンツ作成",
        create_questionnaire: "アンケート作成",
        create_test: "テスト作成",
        create_view_contents: "閲覧コンテンツ作成",
        currently_registered_files: "現在、登録されているファイル",
        delete_contents_faild: "コンテンツの削除に失敗しました。",
        descriptive: "記述式",
        display_string: "画面表示名",
        enter_task_details: "課題内容の入力",
        enter_url: "外部URLを入力する",
        enter_url: "外部URL入力",
        excel: "Excel",
        explanation: "解説",
        explanation_appendices: "解説の補足資料",
        explanation_appendices_guide: "解説に補足資料を付ける",
        external_links: "外部リンク",
        file_name: "ファイル名",
        file_size: "ファイルサイズ",
        file_upload: "ファイルアップロード",
        finish: "終了",
        fixation: "固定",
        folder_list: "フォルダ一覧",
        grading_method: "採点方法",
        how_to_create_questionnaire: "アンケートの作成方法",
        how_to_create_test: "テストの作成方法",
        input_contents: "入力コンテンツ",
        input_contents_guide: "テストやアンケートなどユーザーに入力してもらうコンテンツを登録します。",
        input_expression: "入力式",
        input_format: "入力形式",
        insert_confirmation: "入力された内容でコンテンツを登録します。よろしいですか？",
        load_existing_questionnaire: "既存のアンケートを読み込み",
        load_existing_test: "既存のテストを読み込み",
        loading_template: "テンプレートの読み込み",
        manual: "手動",
        minutes: "分",
        minutes_ago: "分前",
        movie: "動画",
        multiple_selection: "複選式",
        music: "音声",
        on_screen: "画面から作成",
        on_template: "テンプレートから作成",
        order_of_questions: "出題順",
        output_contents: "出力コンテンツ",
        output_contents_guide: "修了証や参考資料などユーザーがダウンロードするコンテンツを登録します。",
        passing_score: "合格点数",
        passing_score_guide: "作成中のテストの合格点数：",
        pdf: "PDF",
        phase_answer_setting: "回答設定",
        phase_creation_method: "作成方法",
        phase_overall_setting: "全体設定",
        phase_question_setting: "質問設定",
        phase_test_answer_setting: "解答設定",
        phase_test_question_setting: "設問設定",
        placeholder_display_string: "○○へのリンク",
        placeholder_pledge: "○○の誓約書",
        playback_time: "再生時間",
        pledge: "誓約書",
        point: "点",
        ppt: "PowerPoint",
        question: "質問",
        question_appendices: "質問文の補足資料",
        question_appendices_guide: "質問に補足資料を付ける",
        question_body: "質問文",
        question_count: "質問数",
        question_count_specification: "出題数の指定",
        question_detail: "質問内容",
        question_empty: "質問がありません。",
        question_one_answer: "一問一答形式",
        questionnaire: "アンケート",
        questionnaire_list: "アンケート一覧",
        questionnaire_name: "アンケート名",
        questionnaire_overall_setting: "アンケート全体の設定",
        questionnaire_overall_setting_detail: "アンケート全体の設定内容",
        questionnaires_in_making: "作成中のアンケート",
        questions_number: "出題数",
        random: "ランダム",
        reference: "参考資料",
        referenced_questionnaire: "参照するアンケート",
        referenced_test: "参照するテスト",
        regist_faild_guide: "コンテンツの登録に失敗しました。",
        regist_success_guide: "コンテンツが正常に登録されました。",
        registration_method: "登録方式",
        select_questionnaire: "参照するアンケートを選択する",
        select_test: "参照するテストを選択する",
        set_time_limit_unit: "（分）",
        setting_questions_number_and_passing_score: "出題数と合格点数の設定",
        setting_questions_number_and_passing_score_guide: "出題数と合格点数はこちらからも設定いただけます。",
        show_commentary: "テスト不合格時の解説表示",
        single_selection: "単選式",
        size: "サイズ",
        task: "課題提出",
        task_description: "課題説明",
        task_name: "課題名",
        test: "テスト",
        test_answer_format: "テスト解答形式",
        test_answer_method: "解答形式",
        test_format: "テスト形式",
        test_list: "テスト一覧",
        test_name: "テスト名",
        test_overall_setting: "テスト全体の設定",
        test_overall_setting_detail: "テスト全体の設定内容",
        test_question: "設問",
        test_question_appendices: "問題文の補足資料",
        test_question_appendices_guide: "問題文に補足資料を付ける",
        test_question_body: "問題文",
        test_question_count: "設問数",
        test_question_detail: "設問内容",
        test_question_empty: "設問がありません。",
        tests_in_making: "作成中のテスト",
        time_limit: '制限時間',
        total_weight: "配点の合計",
        type: "種類",
        upload_file: "ファイルをアップロードする",
        upload_to_certificate: "修了証のアップロード",
        upload_to_file: "ファイルのアップロード",
        upload_to_pledge: "誓約書のアップロード",
        url: "URL",
        url_scheme: "https://",
        view_contents: "閲覧コンテンツ",
        view_contents_guide: "教材に使用するコンテンツを登録します。",
        weight: "配点",
        word: "Word",
      },
      users: {
        title_index: 'ユーザー一覧',
        title_create: 'ユーザー追加',
        title_edit: 'ユーザー編集',
        group: 'グループ',
        title_bulk_update: 'ユーザー一括更新',
        masterdata: 'マスターデータ',
        title_edit: 'ユーザー編集',
        user_photo: '画像',
        password_init: 'パスワード初期化',
        title_bulk_update: 'ユーザー一括更新',
        phase_user_select: '対象選択',
        phase_operation_select: '操作選択',
        balk_update_description_phase_1: '操作を行う対象を選択してください。',
        balk_update_description_phase_2: '行う操作を選択してください。',
        user_delete: 'ユーザー削除',
        balk_update_password_initialize: '以下の対象者のパスワードを初期化します。',
        target_user: '対象者',
        bulk_password_init_confirm: '選択したユーザーのパスワードを初期化します。よろしいですか？',
        password_init_confirm: 'パスワードを初期化します。よろしいですか？',
        password_init_completed: 'パスワードを初期化しました。',
        user_delete_confirm: '選択したユーザーを削除します。よろしいですか？',
      },
      logs_management: {
        operation_management: '運用管理',
        operation_log_management: '操作ログ管理',
        log_management: 'ログ管理',
        filter: '絞り込み',
        login_code: 'ユーザーID',
        operation: '操作',
        search_range: '検索範囲',
        order: '並び順',
        ascending_order: '昇順',
        descending_order: '降順',
        search: '検索',
        excel_output: 'Excel出力',
        cancel: 'キャンセル',
        date_and_time: '日時',
        ipaddress: 'IPアドレス',
        detail: '詳細',
        not_found: '該当する情報がありません。',
        operation_log_output: '操作ログのExcel出力',
        dash: '~',
        other: 'その他',
      },
      operations: {
        general: '全般',
        attendance: '受講',
        answer: '回答',
        initial_display: '初期表示',
        get_list: '一覧取得',
        get_detail: '詳細取得',
        register: '登録',
        edit: '編集',
        delete: '削除',
        login: 'ログイン',
        logout: 'ログアウト',
      },
      functions: {
        questionnaire: 'アンケート',
        course: 'コース',
        contents: 'コンテンツ',
        operation_log_management: '操作ログ管理',
        common: '一般',
      },
      groups: {
        belonging_group_count: '所属グループ数',
        child_group: '子グループ',
        flat: 'フラット',
        group: 'グループ',
        no_parent: 'なし',
        parent_group: '親グループ',
        parent_group_name: '親グループ名',
        parent_group_code: '親グループコード',
        title_edit:'グループ追加・編集',
        title_index: ' グループ一覧',
        tree: 'ツリー',
      },
      settings: {
        title: '設定一覧',
        entry: '利用申請',
        summary_of_entry: '利用申請機能に関連するシステム設定を行います。',
        edit: '編集'
      },
      entry_settings: {
        title: '利用申請',
        use_of_entry_function: '利用申請機能の使用',
        confirm_terms: '申請時の利用規約確認',
        auto_approval: '申請の自動承認',
        notify_entry: '新規申請のメール通知',
        term_of_validity: '登録用URLの有効期間',
        auto_issuance: 'ユーザーIDの自動発行',
        do: 'する',
        dont: 'しない',
        minute: '分',
        hour: '時間',
        day: '日',
        save_complete: '設定を更新しました。',
        cancel: 'キャンセル',
        save: '保存',
      },
      courses: {
        course_edit: 'コース編集',
        overall_setting: '全体設定',
        detail_setting: '詳細設定',
        creation_target: '作成対象',
        select_classification: '分類を選択',
        select_course: 'コースを選択',
        icon: 'アイコン',
        course_duration: '受講期間',
        order_of_attendance: '受講順番',
        from_begining: '最初から',
        from_anywhere: 'どこからでも',
        select_contents: 'コンテンツ選択',
        contents_unselected: 'コンテンツが設定されていません。',
        belonging_classification: '属する分類',
        belonging_course: '属するコース',
        select_contents: 'コンテンツ選択',
        seted_contents: '設定されたコンテンツ',
        course_unregist: "コースが登録されていません。",
        course_count: "コース数",
        chapter_unregist: "章が登録されていません。",
        chapter_count: "章数",
        course_list: "コース一覧",
        level: "レベル",
        child_elements_number: "子要素数",
        chapter_list: "章一覧",
        regist_faild_guide: "コースの登録に失敗しました。",
        regist_success: "コースが正常に登録されました。",
        contents_count: "コンテンツ数",
      },
    },
    buttons: {
      add: '追加',
      adoption: '適用',
      bulk_update: '一括更新',
      cancel: 'キャンセル',
      close: '閉じる',
      confirm: '確認',
      create_new: '新規作成',
      delete: '削除',
      edit: '編集',
      excel_output: 'Excel出力',
      filter: '絞り込み',
      list_operation: '一覧操作',
      next: '次へ',
      other: 'その他',
      read_from_file: 'ファイルから読み込み',
      register: '登録',
      return: '戻る',
      search: '検索',
      select: '選択',
      sending: '送信',
      update: '更新',
    },
    messages: {
      close_modal_confirm: '{modalTitle}画面を閉じますか？入力された内容は破棄されます。',
      contact_admin_about_email: 'メールが届かない場合は管理者にお問い合せください。',
      delete_confirmation: '削除してよろしいですか？',
      delete_target: '以下の{target}を削除します。',
      deleted: '{target}を削除しました。',
      excel_output_description: '{target}のデータをExcelファイルに出力します。',
      format_description_date: '年月日の入力ができます。',
      format_description_number: '数値のみ入力可能となります。符号、小数点含めて{count}桁入力できます。',
      format_description_select: 'リストの中から値を選択させます。',
      format_description_textarea: '{count}文字まで入力可能です。改行できます。',
      format_description_textbox: '{count}文字まで入力可能です。改行できません。',
      input_contents_confirm: '入力内容をご確認ください。',
      operation_completed: '{operation}が完了しました。',
      registered: '{target}を登録しました。',
      return_confirm: '{displayTitle}画面に戻りますか？\n現在入力している内容は破棄されます。',
      start_excel_output: 'Excel出力を開始しました。',
      target_delete_confirm: '{target}を削除しますか？',
      update_confirm: '以下の内容で更新します。よろしいですか？',
      updated: '{target}を更新しました。',
    },
    items: {
      add_target: '{target}の追加',
      all: '全て',
      appendix: '補足資料',
      asc: '昇順',
      chapter: '章',
      classification: '分類',
      confirm: '確認',
      contents: 'コンテンツ',
      course: 'コース',
      course_end_at: '受講終了日',
      course_start_at: '受講開始日',
      created_at: '作成日',
      data: 'データ',
      date: '日付',
      datetime: '日時',
      default: '標準',
      default_value: '初期値',
      delete_target: '{target}の削除',
      desc: '降順',
      detail: '詳細',
      display_order: '表示順番',
      do: 'する',
      do_not: 'しない',
      edit_target: '{target}の編集',
      email: 'メールアドレス',
      email_confirm: 'メールアドレス(確認用)',
      excel_output: '{target}のExcel出力',
      execution: '実行',
      folder: 'フォルダ',
      group_code: 'グループコード',
      group_name: 'グループ名',
      indefinite_period: '無期限',
      input: '入力',
      input_required_optional: '入力の必須・任意',
      invalid: '無効',
      item: '項目',
      item_name: '名称',
      keyword: 'キーワード',
      list: '一覧',
      login_code: 'ユーザーID',
      name: '氏名',
      not_to_send: '送信しない',
      note: '備考',
      number: '数値',
      operational_management: '運用管理',
      optional: '任意',
      order: '並び順',
      overview: '概要',
      page: 'ページ',
      password: 'パスワード',
      password_confirm: 'パスワード(確認用)',
      password_hidden: '●●●●●',
      permission: '権限',
      preview: 'プレビュー',
      question: '問',
      required: '必須',
      search_target: '検索対象',
      select: '選択',
      setting: '設定',
      sort: '並び替え',
      tag: 'タグ',
      target_in_creating: '作成中の{target}',
      target_in_editing: '編集中の{target}',
      target_setting: '{target}の設定',
      terms_of_service: '利用規約',
      to_add_target: '{target}を追加する',
      to_edit_target: '{target}を編集する',
      to_optional_items: '任意入力項目とする',
      to_required_items: '必須入力項目とする',
      to_send: '送信する',
      unselected: '未選択',
      updated_at: '最終更新日',
      user_name: 'ユーザー名',
      valid: '有効',
      view_more: 'さらに表示する',
    },
    tags: {
      can_add_new_tag: 'タグ名を入力して新しいタグを登録',
      create_new_tag: 'タグを新規作成しました。',
      display_selected_tags: '選択したタグが表示されます',
      not_matching_keywords: 'キーワードに一致するタグがありません',
      search_by_keyword: 'キーワードを入力して絞り込み',
      select_tag: 'タグを選択',
      tag_name: 'タグ名',
    },
    master_fields_input: {
      click_to_select: 'クリックして選択',
    },
    errors: {
      name_duplication: '同名の{item}が既に登録されています。{item}名を変更してください。',
      not_found: '該当する情報がありません。',
      not_selected_execution_target: '実行対象が選択されていません。',
      register_error: 'エラーが発生しました。最初からやり直してください。',
    },
    basic_input: {
      count_message: '{count} 文字',
      count_message_with_maxlength: '{maxlength} 文字中 {count} 文字入力',
    },
    status: {
      attended: '完了',
      in_attending: '受講中',
      not_attended: '未受講',
      expired: '期間外',
    },
    search: {
      by_keyword: 'キーワード検索',
      input_keyword: 'キーワードを入力',
    },
    pagination: {
      info: '全 {count} 件中 {start}件 ～ {end}件を表示',
      display: '表示件数',
    },
    dropzone: {
      dict_default_message: "ここをクリックするかファイルをドラッグアンドドロップしてアップロード",
      dict_fallback_message: "ご使用のブラウザはドラッグアンドドロップに対応しておりません",
      dict_fallback_text: "こちらのフォームからファイルをアップロードしてください",
      dict_file_too_big: "ファイルサイズの上限は {'{{'}maxFilesize{'}}'}MB です",
      dict_invalid_file_type: "この形式のファイルはアップロードできません",
      dict_response_error: "サーバーエラーが発生しました(コード: {statusCode})",
      dict_cancel_upload: "キャンセル",
      dict_upload_canceled: "アップロードをキャンセルしました",
      dict_cancel_upload_confirmation: "アップロードをキャンセルしますか？",
      dict_remove_file: "削除",
      dict_max_files_exceeded: "これ以上アップロードできません",
      max_files_message: "最大 {maxFiles}件まで",
      file_count_message: "現在 {fileCount}件",
      max_files_exceeded: "アップロードできる上限数に達したため、これ以上アップロードできません",
      max_files_reached_delete: "アップロードできる上限数に達したため、ファイルは追加されませんでした",
    },
    entries: {
      title: '利用申請',
      create_phase_terms: '規約への同意',
      create_phase_identification: '本人確認',
      create_phase_input: '情報入力',
      create_phase_confirm: '申請確認',
      disagree: '同意しない',
      agree: '同意する',
      entry: '申請',
      explain_terms: '利用申請をする際には利用規約への同意が必要です。\r\n以下のリンクから内容をご確認の上、ご同意頂ける場合にのみ「同意する」ボタンをクリックして次の画面へお進みください。',
      confirm_check: '利用規約を確認しました。',
      explain_email: '下記にメールアドレスを入力し、送信ボタンを押して下さい。\r\n登録用のURLをお知らせします。',
      notify_url_send_minute: '入力いただいたメールアドレスに登録用のURLを送信しました。\r\nURLにアクセスし、{time}分以内に申請をお願いいたします。',
      notify_url_send_hour: '入力いただいたメールアドレスに登録用のURLを送信しました。\r\nURLにアクセスし、{time}時間以内に申請をお願いいたします。',
      notify_url_send_day: '入力いただいたメールアドレスに登録用のURLを送信しました。\r\nURLにアクセスし、{time}日以内に申請をお願いいたします。',
      explain_entry: '申請される情報を入力してください。',
      explain_confirm: '申請内容をご確認ください。',
      notify_acceptance: '申請を受け付けました。\r\n申請結果は申請いただいたメールアドレスにお知らせします。\r\n尚、結果の通知には少々お時間をいただきます。予めご了承ください。\r\n(この画面は閉じてください)',
      notify_acceptance_with_approval: '申請を受け付けました。\r\nユーザーIDとログインのURLは申請いただいたメールアドレスにお知らせしています。',
    },
    policies: {
      policy:'ポリシー',
      password: 'パスワードポリシー',
      loginCode: 'ユーザーIDポリシー',
    },
    dashboard: {
      status: '受講状況'
    },
    contentsTags: {
      tag_name: 'タグ名',
      select_tag: 'タグを選択',
      create_new_tag: 'タグを新規作成しました。',
      display_selected_tags: '選択したタグが表示されます',
      search_by_keyword: 'キーワードを入力して絞り込み',
      not_found: 'キーワードに一致するタグがありません',
      not_display: '表示できるタグがありません',
      can_add_new_tag: 'タグ名を入力して新しいタグを登録',
      delete_confirm: 'データを削除します。よろしいですか？',
    },
    password_resets: {
      create_phase_finish: '完了',
      create_phase_identification: '本人確認',
      create_phase_new_password: '新しいパスワード入力',
      description_identification: '学びばこで利用されているユーザーIDとメールアドレスを入力し、送信ボタンを押してください\r\nパスワードリセット用のURLをお知らせします。',
      description_new_password: '新しいパスワードを入力してください。',
      notify_url_send_day: '入力いただいたメールアドレスにパスワードリセット用のURLを送信しました。\r\nURLにアクセスし、{time}日以内に申請をお願いいたします。',
      notify_url_send_hour: '入力いただいたメールアドレスにパスワードリセット用のURLを送信しました。\r\nURLにアクセスし、{time}時間以内に申請をお願いいたします。',
      notify_url_send_minute: '入力いただいたメールアドレスにパスワードリセット用のURLを送信しました。\r\nURLにアクセスし、{time}分以内に申請をお願いいたします。',
      reset_completed: 'パスワードをリセットしました。\r\n新しいパスワードで学びばこの利用を開始してください。',
      title: 'パスワードのリセット',
    },
    user_settings: {
      title_change_password: 'パスワード変更',
      title_edit: 'ユーザー情報変更',
      user_photo: "画像",
    },
  }
};
